'use strict';

var React = require('react');

var SvgTypeMinor = function SvgTypeMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m10.824 3.58 3.93 11.006a1 1 0 0 0 .942.664h.429a.875.875 0 0 1 0 1.75h-4.375a.875.875 0 0 1 0-1.75c.248 0 .42-.245.337-.479l-.766-2.146h-4.392l-.766 2.146a.358.358 0 0 0 .337.479.875.875 0 0 1 0 1.75h-2.625a.875.875 0 0 1 0-1.75.367.367 0 0 0 .345-.243l4.081-11.426a.875.875 0 0 1 .824-.581h.875c.37 0 .7.232.824.58Zm-3.27 7.295 1.571-4.398 1.57 4.398h-3.14Z"
  }));
};

exports.SvgTypeMinor = SvgTypeMinor;
